/**
 * Iter-52.47 — Log an "I want an extra profile" WhatsApp handoff.
 *
 * Called by the three call sites where a user taps a button that
 * hands off to WhatsApp for manual profile-add payment:
 *   1. Profiles.jsx  — ProfileLimitModal "Contact us on WhatsApp"
 *   2. PlanCapBanner.jsx — over_profile_needs_manual_review "Message us"
 *   3. PlanCapBanner.jsx — over_profile_scheduled_delete_at "Keep profiles"
 *
 * Fire-and-forget: this MUST NOT block the WhatsApp hand-off. If the
 * network is dead or the endpoint 500s, the button still opens
 * `wa.me/…` — the admin just doesn't see this particular tap in the
 * telemetry, which is a graceful degradation.
 *
 * @param {string} source short human label of WHICH button was tapped
 *                        — surfaced in the admin ledger so we can
 *                        distinguish "hit their profile limit" from
 *                        "keep profiles after over-cap delete warn".
 */
import { api } from './api';

export function logExtraProfileRequest(source) {
  try {
    api.post('/users/extra-profile-request', { source: source || 'unknown' })
       .catch(() => { /* silent — WhatsApp handoff already opened */ });
  } catch {
    /* noop — never break the handoff on a telemetry error */
  }
}
